import { toast } from '@/components/ui/helpers/toast';

import type { CompleteStripeSetupIntentResponse } from '@/services/internal-api/subscriptions/types/subscription-api-service-types';

export function toastRecoveryOutcome(response: CompleteStripeSetupIntentResponse): void {
  if (response.subscriptionActivated === false) {
    toast.error(
      response.subscriptionActivationFailureReason ??
        'We couldn\'t process your payment. Please try a different card.',
    );
  } else {
    toast.success('Payment method added. Subscription restored.');
  }
}
